import { useNavigate } from "react-router-dom";
import NikeIcon from "../../assets/Images/NikeIcon.png";
import Button from "../../components/atoms/buttons/Button";
import { ROUTES } from "../../constants";

function BrandDashboardHeader({
  handleCreateMagnet,
  name,
  profile_image_url,
  id: brandId,
}: { handleCreateMagnet: () => void } & Pick<Brand, "name" | "profile_image_url" | "id">) {
  const navigate = useNavigate();
  return (
    <div className="justify-center font-sora">
      {/* Top Magnets */}
      <div className="absolute -mt-[115px] 2xl:-mt-[120px]">
        <h1 className="text-left text-4xl font-semibold text-white 2xl:text-5xl">Magnets</h1>
      </div>

      {/* Brand */}
      <div className="mb-5 mt-10 flex flex-row items-center justify-between md:flex-row md:gap-10 ">
        <div
          className=" flex cursor-pointer  items-center justify-center gap-3"
          onClick={() => navigate(`${ROUTES.BRAND_PUBLIC_PROFILE}/${brandId}`)}
        >
          <img
            className=" h-16 w-16 max-w-xs rounded-lg border border-[#C0C0C0] border-opacity-40 object-cover 2xl:h-20 2xl:w-20 "
            src={profile_image_url || NikeIcon}
            alt={name}
          />
          <p className=" text-left text-4xl font-semibold text-white 2xl:text-5xl">{name}</p>
        </div>

        {/* Buttons */}
        <div className="flex items-end gap-5">
          <Button
            text="CREATE MAGNET"
            variant="magnetiqSolid"
            additionalClasses="xl:text-xs 2xl:text-sm xl:px-5 xl:py-2 2xl:px-7 2xl:py-3"
            onClick={handleCreateMagnet}
          />
        </div>
      </div>
      <p className="mt-10 text-left font-sora text-sm font-semibold text-white xl:text-lg">YOUR MAGNETS</p>
    </div>
  );
}
export default BrandDashboardHeader;
